import { useEffect, useState } from "react";
import { PAYMENTS_UNLOCK_DATE } from "@/lib/config";

/**
 * Live countdown timer to the payments-mode unlock date.
 * Renders as: "12d · 04h · 27m · 13s until payments unlock"
 * Auto-updates every second. When target passes, shows "🚀 Payments unlocked".
 */
export const Countdown = ({ compact = false, testId = "countdown" }) => {
  const target = new Date(PAYMENTS_UNLOCK_DATE).getTime();
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const diff = Math.max(0, target - now);
  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff % 86_400_000) / 3_600_000);
  const minutes = Math.floor((diff % 3_600_000) / 60_000);
  const seconds = Math.floor((diff % 60_000) / 1000);

  if (diff <= 0) {
    return (
      <div data-testid={testId} className="font-mono text-xs tracking-[0.25em] uppercase text-[#22c55e]">
        🚀 Payments unlocked · sign in to activate
      </div>
    );
  }

  if (compact) {
    return (
      <span
        data-testid={testId}
        className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#a855f7]"
      >
        {days}d · {String(hours).padStart(2, "0")}h · {String(minutes).padStart(2, "0")}m · {String(seconds).padStart(2, "0")}s
      </span>
    );
  }

  const Cell = ({ n, label }) => (
    <div className="flex flex-col items-center">
      <div className="font-heading font-black text-2xl sm:text-3xl md:text-4xl text-white tabular-nums leading-none">
        {String(n).padStart(2, "0")}
      </div>
      <div className="font-mono text-[9px] tracking-[0.3em] uppercase text-[#a855f7] mt-1">{label}</div>
    </div>
  );

  return (
    <div data-testid={testId} className="flex items-center justify-center gap-4 sm:gap-8">
      <Cell n={days} label="days" />
      <span className="text-[#a855f7] text-2xl font-black">·</span>
      <Cell n={hours} label="hrs" />
      <span className="text-[#a855f7] text-2xl font-black">·</span>
      <Cell n={minutes} label="min" />
      <span className="text-[#a855f7] text-2xl font-black">·</span>
      <Cell n={seconds} label="sec" />
    </div>
  );
};
